import React from 'react';
import { INITIAL_LANDING_PAGE_DATA } from 'src/constants';

export const MarketingSiteContext = React.createContext({
  config: {
    showBadge: false,
  },
  pages: { ...INITIAL_LANDING_PAGE_DATA },
});
